import React, { useMemo } from 'react'

import { digObject } from '@domain-group/javascript-utils'

import { Table, Text } from '@domain-group/suit-theme'

import formatDate from '@functions/formatDate'

import useSelector from '@hooks/useSelector'

import { LoginSessionModel } from '@models/types'

import type { EntitiesState } from '@redux/entities'

const buildColumns = (users: EntitiesState['users']) => [
  {
    cellProps: {
      width: 250,
    },
    title: 'Date',
    dataKey: 'dates',
    render: (datesObject: object) => {
      const createdAt = digObject(datesObject, 'created.date_time', '')
      const formattedDate = formatDate(createdAt, 'dd/MM/yyyy HH:mm', "ccc dd LLL y 'at' hh:mma")

      return formattedDate
    },
  },
  {
    title: 'Username',
    dataKey: 'user_id',
    render: (user_id: number) => users[user_id]?.username,
  },
  {
    title: 'IP Address',
    dataKey: 'login_ip_address',
  },
  {
    title: 'Latitude',
    dataKey: 'latitude',
  },
  {
    title: 'Longitude',
    dataKey: 'longitude',
  },
]

const LoginSessionsTable = (props: { loginSessions: LoginSessionModel[] }) => {
  const { loginSessions } = props

  const users = useSelector(reduxState => reduxState.entities.users)

  const memoColumns = useMemo(() => buildColumns(users), [loginSessions.length])

  return (
    <Table
      boxProps={{ border: 'none', maxHeight: 800, overflowY: 'auto' }}
      // @ts-expect-error TS2322
      columns={memoColumns}
      data={loginSessions}
      scroll={{ x: 800 }}
      stickyHeader
    />
  )
}

export default React.memo(LoginSessionsTable)
